import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { PopupsStore } from '../../stores/Popups/PopupsStore';

export const PopupManager: FC = observer(() => {
  return (
    <>
      {PopupsStore.data.map((popupInstance) => {
        const { id, Component, options } = popupInstance;

        if (!Component) {
          return null;
        }

        return (
          <Component
            key={id}
            popupInstance={popupInstance}
            {...options}
          />
        );
      })}
    </>
  );
});
